import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';

export const baseUri = 'https://graph.escena.digital';
// export const baseUri = 'http://localhost:4000';
const httpLink = createHttpLink({
  uri: `${baseUri}/graphql`,
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('escenaToken');
  return {
    headers: {
      ...headers,
      EscenaReferrer: document.referrer,
      Authorization: token ? `Bearer ${token}` : '',
    },
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});



// WEBPACK FOOTER //
// ./src/client.js